export default {
  guide: {
    start: 'Anza',
    whatsNext: 'Nini kinafuata?',
    dontShowAgain: 'Usionyeshe dirisha hili tena',
    needHelp: 'Unahitaji msaada?',
    userManual: 'Mwongozo wa mtumiaji',
    chooseFormat: 'Chagua muundo unaopendelea',
    pdfManual: 'Mwongozo wa PDF',
    downloadPdf: 'Pakua na usome bila mtandao',
    videoTutorial: 'Mafunzo ya video',
    watchStepByStep: 'Tazama mwongozo wa hatua kwa hatua',
    firstStepTitle: 'Karibu! Tutakuongoza kupitia hatua zako za kwanza.',
    activationKey: {
      title: 'Funguo mpya za uanzishaji zimesajiliwa kwa mafanikio.',
      description:
        'Tuma funguo za uanzishaji kwa wakulima/wakusanyaji wa data ili waweze kujisajili chini ya shirika lako.',
      nextStep: 'Bofya kitufe cha Hatua ili kuchagua muundo unaotaka kushiriki funguo.',
    },
    dashboard: {
      userManagement: 'Usimamizi wa watumiaji',
      userManagementDescription: 'Sehemu ya Usimamizi wa watumiaji inakuwezesha:',
      listUser: 'Kuona orodha ya sasa ya watumiaji wa simu na wasimamizi',
      addUser: 'Kuongeza watumiaji wapya au kuwaalika watumiaji kwa kutumia funguo za uanzishaji',
      managePermission: 'Kusimamia ruhusa, mipango ya uanachama na majukumu',
      farmManagement: 'Usimamizi wa mashamba',
      farmManagementDescription: 'Nenda kwenye sehemu ya Usimamizi wa mashamba ili:',
      listFarm: 'Kuona orodha ya mashamba na wakulima waliosajiliwa',
      addFarm: 'Kuongeza mashamba mapya moja moja au kwa wingi',
      title: 'Dashibodi',
      description:
        'Kadri unavyoongeza watumiaji na mashamba zaidi, utaweza kuona muhtasari kwenye dashibodi kuu.',
    },
    ddsDashboard: {
      title: 'Anza na sehemu ya “Unda Ripoti Mpya ya Uangalizi Stahiki” ili kuanza.',
      alreadyHaveFarm: 'Je, tayari una data ya shamba?',
      description:
        'Utakuwa na chaguo la kuongeza data ya shamba lako katika hatua ya pili ya mchakato wa "Unda Ripoti Mpya ya Uangalizi Stahiki".',
      createNewReport: 'Unda ripoti mpya',
      creatingReport: 'Kuunda ripoti ya uangalizi stahiki',
      sharingWithOperator: 'Kushiriki na mwendeshaji',
      riskMitigation: 'Upunguzaji wa hatari',
    },
    productionPlace: {
      title: 'Pakia data ya shamba lako',
      description: 'Pakia data ya shamba lako moja moja au kwa wingi kwa kubofya kitufe cha "Ongeza Mpya".',
      allowedFormat: 'Kwa sasa, tunakubali miundo ifuatayo kwa upakiaji wa data kwa wingi:',
    },
    reportDetail: {
      title: 'Kwanza, tafadhali jaza maelezo yanayohusiana na ripoti yako.',
      description: 'Unahitaji msaada? Angalia miongozo yetu ya watumiaji (PDF au video) kwa kubofya hapa:',
      nextStep: 'Baada ya kumaliza, bofya "Inayofuata" ili kuendelea kwenye hatua ambayo utaweza kupakia data ya uzalishaji wa shamba lako.',
    },
    adminRegistered: {
      title: 'Mtumiaji mpya wa msimamizi amesajiliwa kwa mafanikio.',
      description:
        'Tuma funguo za uanzishaji kwa wakulima/wakusanyaji wa data ili waweze kujisajili chini ya shirika lako.',
      nextStep: 'Nini kinafuata? Anza kuwaingiza wakulima na wakusanyaji wa data.',
    },
  },
};
